import React, { useState } from 'react';
import { LoginImg1, LoginImg2, LoginImg3, NavigatePrevimg } from '../../../assets/images';

import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption
} from 'reactstrap';

const items = [
  {
    key: 1,
    src: LoginImg1,
    altText: 'Real-Time Insights',
    caption: 'Monitor the business cashflows, burn rate, budgets, expected taxes, etc.'
  },
  {
    key: 2,
    src: LoginImg2,
    altText: 'File Manager',
    caption: 'View all your important documents and files in one place.'
  },
  {
    key: 3,
    src: LoginImg3,
    altText: 'Billing & Invoicing',
    caption: 'Add and edit your invoices in the simplest manner anytime.'
  }
];

const ImageSlider = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  }

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  }

  const goToIndex = (newIndex: any) => {
    if (animating) return;
    setActiveIndex(newIndex);
  }

  const slides = items.map((item) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.key}
      >
        <img className='login-image' src={item.src} alt={item.altText} />
        <div className='carousel-text'>
          <h5 style={{ fontSize: '24px', color: '#f4f4f4' }}>{item.altText}</h5>
          <p style={{ fontSize: '16px', color: '#f4f4f4' }}>{item.caption}</p>
        </div>
      </CarouselItem>
    );
  });

  return (
    <Carousel
      activeIndex={activeIndex}
      next={next}
      previous={previous}
    >
      <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} />
      {slides}
    </Carousel>
  );
}

export default ImageSlider